// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nv-0";
export var assigneeDetails = "_nv-1";
export var assigneeInfo = "_nv-2";
export var dropdownContainer = "_nv-4";
export var dropdownImage = "_nv-5";
export var editAssigneeInfo = "_nv-3";
export var editAssigneeModalContainer = "_nv-6";
export var hidden = "_nv-8";
export var input = "_nv-7";